import { Modal, Pagination, Stack, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react'
import { useQuery } from 'react-query';
import QueryKey from '../QueryKey';
import { capFirstLetter } from '../utils/format';
import LoadingScreen from './loadingScreen';
import { customAlert } from './notify';
import SearchTxtField from './SearchTxtField';
import StyledTableContainer from './StyledTableContainer';
import { useTranslation } from "react-i18next";
import { getAllAgWPgSch } from '../services/agent-service';


function SelectAgent({ handleClose, open, handleSetAgent }) {
    const [pageNumber, setPageNumber] = useState(1);
    const [searchKeyWord, setSearchKeyWord] = useState("");
    const [searchWord, setSearchWord] = useState("");
    const limit = 6;
    const { t } = useTranslation();

    const { isLoading, isError, error, data: agRows } = useQuery(
        [QueryKey.agList, pageNumber, searchKeyWord],
        () => getAllAgWPgSch({ pageNumber, limit, searchKeyWord }),
        {
            keepPreviousData: true
        }
    )
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 660,
        bgcolor: 'background.paper',
        border: '2px solid #ffff',
        boxShadow: 24,
        px: 1.5,
        py: 1.5,
        borderRadius: 2,
    };



    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }


    if (isLoading)
        return <Box sx={{ position: "absolute", top: 0, left: 0 }}><LoadingScreen /></Box>



    const columns = [
        {
            id: 'agName',
            label: t("bo.agent.agName"),
            minWidth: 170
        },
        {
            id: 'agentCode',
            label: t("bo.agent.agCode"),
            minWidth: 170
        },
        {
            id: 'agMobile',
            label: t("bo.agent.contact"),
            minWidth: 170
        },
        {
            id: 'verified',
            label: t("bo.agent.verified"),
            minWidth: 170
        },
    ];


    function verified(custRow) {
        if (custRow.aadhar_verified === 1 || custRow.pan_verified === 1 || custRow.gst_verified === 1)
            return <Typography sx={{ color: "green" }}>Yes</Typography>

        return <Typography sx={{ color: "red" }}>No</Typography>
    }

    async function handleRowClick(custRow) {
        handleSetAgent(custRow);
        handleClose();
    }

    function onSearchBtnClick() {
        setSearchKeyWord(searchWord)
    }




    return (
        <Modal
            open={open}
            onClose={handleClose}
        >
            <Box sx={modalStyle}>
                <Stack direction={'row'} justifyContent='space-between' m={1} >
                    <Typography sx={{ fontWeight: "bold", fontSize: 22 }}>{t("bo.agent.selAg")}</Typography>
                    <Stack direction={'row'} justifyContent="end">
                        <SearchTxtField searchKeyWord={searchWord} onSearch={(e) => setSearchWord(e.target.value)} onBtnClick={onSearchBtnClick} placeholder={t("bo.agent.srchAg")} />
                    </Stack>
                </Stack>
                <StyledTableContainer height={"50%"}>
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                    sx={{ color: "#8392AB", fontWeight: "bold", py: 1 }}
                                    key={column.id}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {agRows?.data.map((agRow) => {
                            return (
                                <TableRow hover tabIndex={-1} key={agRow.agentId} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} onClick={() => { handleRowClick(agRow); }}>
                                    {columns.map((column) => {
                                        const value = agRow[column.id];
                                        return (
                                            (column.id === 'agName') ?
                                                <TableCell key={column.id} align={column.align} >
                                                    {capFirstLetter(agRow.agName)}
                                                </TableCell> : (column.id === 'verified') ?
                                                    <TableCell key={column.id} align={column.align} >
                                                        {verified(agRow)}
                                                    </TableCell> :
                                                    <TableCell key={column.id} align={column.align} >
                                                        {column.format && typeof value === 'number' ? column.format(value) : capFirstLetter(value)}
                                                    </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>

                </StyledTableContainer>
                <Stack sx={{ alignItems: "center", mt: 1 }}>
                    <Pagination count={Math.ceil(agRows?.totalLength / limit) || 0} color="primary" page={pageNumber} onChange={(e, v) => setPageNumber(v)} variant="outlined" shape="rounded" />
                </Stack>
            </Box>
        </Modal>
    )
}

export default SelectAgent